var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notificacoes"},[(_vm.show)?_c('div',[_c('b-card',{staticClass:"text-center",attrs:{"bg-variant":_vm.notificacao.tipo,"header":_vm.notificacao.titulo,"text-variant":"white"}},[_c('b-card-text',[_vm._v(" "+_vm._s(_vm.notificacao.texto))])],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }